import axios from '../axiosInstance.js'

const AuthAPI = {
    login: {
        method: 'post',
        path: '/auth/login/google',
        send: function (payload) {
            return axios[this.method](this.path, payload)
        },
    },
    me: {
        method: 'get',
        path: '/me',
        send: function (payload) {
            return axios[this.method](this.path, payload)
        },
    },
    logout: {
        method: 'get',
        path: '/auth/logout',
        send: function (payload) {
            return axios[this.method](this.path, payload)
        },
    },
}

export default AuthAPI
